import React from 'react';
import { Bar } from "react-chartjs-2";

import Grid from '@material-ui/core/Grid';

export const InscricoesCandidatosPorData = ({ inscricoes }) => {
    return (
        <>
            {inscricoes.length > 0 &&
                <Grid item md={12} lg={12} >
                    <Bar
                        data={{
                            labels: inscricoes.map((i) => i.dataFormatada),
                            datasets: [
                                {
                                    label: "Inscrições Incompletas",
                                    data: inscricoes.map((i) => i.candidatosIniciaramInscricao),                                    
                                    backgroundColor: "#0291bd",
                                    borderColor: "#0291bd",
                                },
                                {
                                    label: "Inscrições Aguardando Pagamento",
                                    data: inscricoes.map((i) => i.candidatosAguardandoPagamento),
                                    backgroundColor: "#c79903",
                                    borderColor: "#c79903",
                                },
                                {
                                    label: "Inscrições Não Finalizadas",
                                    data: inscricoes.map((i) => i.candidatosNaoFinalizados),
                                    backgroundColor: "#a51616",
                                    borderColor: "#a51616",
                                },
                                {
                                    label: "Inscrições Finalizadas",
                                    data: inscricoes.map((i) => i.candidatosFinalizaramInscricao),
                                    backgroundColor: "#6cbd02",
                                    borderColor: "#6cbd02",
                                },
                            ],
                        }}
                        options={{
                            elements: {
                                line: {
                                    tension: 0.5,
                                },
                            },
                            plugins: {
                                title: {
                                    text: "Candidatos Inscritos por Data",
                                },
                                legend: {
                                    position: 'top',
                                },
                            },
                        }}
                    />
                </Grid>
            }
        </>
    )
}

export default InscricoesCandidatosPorData;